import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Paper, CircularProgress, Alert } from '@mui/material';
import FormCurso from '../../components/Cursos/FormCurso';
import { criarCurso, obterCurso, atualizarCurso } from '../../services/cursoService';

const CriarEditarCursoPage = () => {
  const [curso, setCurso] = useState(null);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditMode = !!id;

  useEffect(() => {
    if (isEditMode) {
      const fetchCurso = async () => {
        setLoading(true);
        try {
          const data = await obterCurso(id);
          console.log('Curso obtido para edição:', data); // Log para depuração
          setCurso(data);
        } catch (error) {
          console.error('Erro ao buscar curso:', error);
          setErro('Erro ao buscar curso.');
        } finally {
          setLoading(false);
        }
      };

      fetchCurso();
    }
  }, [id, isEditMode]);

  const handleSubmit = async (formData) => {
    setLoading(true);
    try {
      if (isEditMode) {
        await atualizarCurso(id, formData);
      } else {
        await criarCurso(formData);
      }
      navigate('/cursos');
    } catch (error) {
      console.error('Erro ao salvar curso:', error);
      setErro('Erro ao salvar curso.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>
        {isEditMode ? 'Editar Curso' : 'Criar Novo Curso'}
      </Typography>
      {loading && <CircularProgress />}
      {erro && <Alert severity="error">{erro}</Alert>}
      {!loading && (
        <FormCurso 
          onSubmit={handleSubmit} 
          cursoInicial={curso}
        />
      )}
    </Paper>
  );
};

export default CriarEditarCursoPage;
